(function () {
  /* -----------------------------------------------
   *  Helpers
   * --------------------------------------------- */

  // Schlüssel pro Produkt (für lokalen Cache) – aus /products/<handle>
  function getProductKey() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? "jdgm_count:" + m[1] : null;
    }

  // Lokalisierter Begriff für "Bewertungen" basierend auf <html lang="">
  function localizedReviewsWord() {
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    if (lang.startsWith('de')) return 'Bewertungen';
    if (lang.startsWith('nl')) return 'beoordelingen';
    if (lang.startsWith('fr')) return 'avis';
    if (lang.startsWith('es')) return 'reseñas';
    return 'reviews';
  }

  // Zahl in alle Badges schreiben (anlegen oder aktualisieren) + A11y
  function writeCountToBadge(count) {
    if (!count && count !== 0) return;
    var text = " (" + count + ")";
    var a11y = count + " " + localizedReviewsWord();

    document.querySelectorAll(".jdgm-prev-badge").forEach(function (badge) {
      // sichtbare Zahl (unser eigener Span)
      var span = badge.querySelector(".jdgm-count-only");
      if (!span) {
        span = document.createElement("span");
        span.className = "jdgm-count-only";
        badge.appendChild(span);
      }
      span.textContent = text;

      // A11y: Screenreader-Label + polite live region
      badge.setAttribute("aria-label", a11y);
      if (!badge.hasAttribute("aria-live")) {
        badge.setAttribute("aria-live", "polite");
      }
    });
  }

  // Zahl aus dem (versteckten) Label oder aus Attributen extrahieren
  function extractCountFromBadge() {
    var firstBadge = document.querySelector(".jdgm-prev-badge");
    if (!firstBadge) return null;

    // 1) Aus Textknoten "123 reviews/Bewertungen"
    var txt = firstBadge.querySelector(".jdgm-prev-badge__text");
    if (txt && txt.textContent) {
      var m = txt.textContent.match(/\d+/);
      if (m) return m[0];
    }

    // 2) Fallback: Attribut(e) verschiedener JDGM-Versionen
    var attr =
      firstBadge.getAttribute("data-number-of-reviews") ||
      firstBadge.getAttribute("data-reviews-count") ||
      (firstBadge.dataset
        ? firstBadge.dataset.numberOfReviews || firstBadge.dataset.reviewsCount
        : null);

    return attr || null;
  }

  // Großes Widget sichtbar machen (wir blenden es per CSS erst sichtbar, wenn geladen)
  function revealWidgets() {
    document
      .querySelectorAll(".jdgm-widget")
      .forEach(function (el) { el.classList.add("jdgm-loaded"); });
  }

  /* -----------------------------------------------
   *  Sofort: Cache anzeigen (zweiter Besuch => instant)
   * --------------------------------------------- */
  var key = getProductKey();
  if (key) {
    try {
      var cached = localStorage.getItem(key);
      if (cached) writeCountToBadge(cached);
    } catch (e) { /* ignore */ }
  }

  /* -----------------------------------------------
   *  Rendering debounced planen
   * --------------------------------------------- */
  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    setTimeout(function () {
      renderScheduled = false;
      var c = extractCountFromBadge();
      if (c != null) {
        writeCountToBadge(c);
        if (key) {
          try { localStorage.setItem(key, c); } catch (e) { /* ignore */ }
        }
      }
    }, 60); // kleiner Debounce, um Batch-Mutationen mitzunehmen
  }

  /* -----------------------------------------------
   *  Events / Observer
   * --------------------------------------------- */

  // JDGM-Events (kommen manchmal recht spät)
  function onJdgmReady() {
    scheduleRender();
    revealWidgets();
  }
  document.addEventListener("jdgm-ready", onJdgmReady);
  document.addEventListener("jdgm_widgets_loaded", onJdgmReady);

  // MutationObserver: reagiert auch auf Text- und Attribut-Änderungen
  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (
        m.type === "characterData" ||
        m.type === "childList" ||
        (m.type === "attributes" &&
          (m.attributeName === "data-number-of-reviews" ||
           m.attributeName === "data-reviews-count"))
      ) {
        scheduleRender();
        break;
      }
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    // so früh wie möglich versuchen
    scheduleRender();

    // gesamten DOM beobachten (Badge wird dynamisch injiziert/aktualisiert)
    try {
      obs.observe(document.documentElement, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["data-number-of-reviews", "data-reviews-count"]
      });
    } catch (e) { /* ignore */ }

    // Fallbacks für langsame Antworten
    setTimeout(scheduleRender, 200);
    setTimeout(scheduleRender, 600);
    setTimeout(scheduleRender, 1200);
    setTimeout(scheduleRender, 2500);
  });
})();
